<form *ngIf="formReady" class="row" [formGroup]="form" (ngSubmit)="submit()">
  <div class="col-12 d-flex justify-content-end mb-3">
    <app-spinner-btn [loading]="isSubmitting" [name]="'SHARED.save' | translate"></app-spinner-btn>
  </div>

  <div class="col-12">
    <div class="row pb-5">
      <div class="col-12">
        <h4>Site Configuration</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="apr_rate" [fullWidth]="true"
                   [label]="'CONFIG.misc.apr_rate' | translate" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="debt_reduction_fee" [fullWidth]="true"
                   [label]="'CONFIG.misc.debt_reduction_fee' | translate" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Distribution Fees</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="fixed_distribution_fee" [fullWidth]="true"
                   label="Fixed Distribution Fee" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="percentage_distribution_fee" [fullWidth]="true"
                   label="Percentage Distribution Fee" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>DS Specific options</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="ds_reduction_percent" [fullWidth]="true"
                   label="DS Reduction Percentage" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="ds_default_fee_amount" [fullWidth]="true"
                   label="DS Default Fee Amount" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="ds_default_fds_reduction" [fullWidth]="true"
                   label="DS Default FDS Reduction" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Percentage Reductions</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="percentage_reduction_good" [fullWidth]="true"
                   label="Good Percentage Reduction" [extraLabel]="true">
        </app-input>
        <app-input type="number" formControlName="percentage_reduction_bad" [fullWidth]="true"
                   label="Bad Percentage Reduction" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="percentage_reduction_decent" [fullWidth]="true"
                   label="Decent Percentage Reduction" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Auto Mandate Options</h4>
      </div>
      <div class="col-6">
        <app-input *ngIf="amountPaid.length" type="select"
                   formControlName="mandates_amount_paid_threshold" [extraLabel]="true" [fullWidth]="true"
                   label="Mandates Amount Paid Threshold" [selectOptions]="amountPaid"
                   [selectLabel]="'label'" [selectValue]="'value'">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Default Microlender Options</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="minimum_offer_to_creditors" [fullWidth]="true"
                   label="Minimum Offer to Creditor per month" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="maximum_percentage_offer_to_creditors" [fullWidth]="true"
                   label="Maximum % offer to Creditors" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Negotiation Options</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="negotiation_fee_percentage" [fullWidth]="true"
                   label="Negotiation Fee Percentage" [extraLabel]="true">
        </app-input>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="default_iva_rate" [fullWidth]="true"
                   label="Default Tax Rate Percentage" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Default Lockout Options</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="lockout_default_percentage" [fullWidth]="true"
                   label="Default % of Microlenders to Creditors" [extraLabel]="true">
        </app-input>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-12">
        <h4>Default Creditor Options</h4>
      </div>
      <div class="col-6">
        <app-input type="number" formControlName="default_monthly_term" [fullWidth]="true"
                   label="Default monthly term for Microlenders" [extraLabel]="true">
        </app-input>
      </div>
    </div>
  </div>
</form>
